import { ReactElement } from "react";
import { FeedbackBlock } from "@twiliointernal/e2-commons-shared-definitions";
import Feedback from "../../feedback/Feedback";

interface FeedbackRendererProps {
  block: FeedbackBlock;
}

const FeedbackRenderer = ({ block }: FeedbackRendererProps): ReactElement => {
  return <Feedback block={block} />;
};

export default FeedbackRenderer;
